module.exports = __webpack_public_path__ + "7312f447a2cc433f16dfa6f46d95a3e9.svg";